document.addEventListener('DOMContentLoaded', function() {
  // Configuración - tiempo para cerrar automáticamente (1000ms = 1 segundo)
  const autoCloseTime = 1000;
  
  // Función para detectar y cerrar automáticamente el popup del carrito
  function setupAutoCloseCart() {
    // Observer para detectar cambios en el DOM
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function() {
        // Buscamos diferentes selectores posibles para el popup de carrito
        const cartPopup = document.querySelector('.cart-popup, .cart-notification, .cart__notification, .cart-drawer, .drawer--cart');
        
        if (cartPopup && window.getComputedStyle(cartPopup).display !== 'none') {
          console.log('Popup de carrito detectado, se cerrará en ' + autoCloseTime + 'ms');
          
          setTimeout(function() {
            // Intentamos diferentes métodos de cierre
            
            // 1. Buscar y hacer clic en un botón de cierre
            const closeButton = cartPopup.querySelector('.cart-popup__close, .cart-notification__close, .drawer__close, .close-cart, .btn-close');
            if (closeButton) {
              closeButton.click();
              console.log('Botón de cierre encontrado y activado');
              return;
            }
            
            // 2. Intentar disparar eventos personalizados que el tema podría estar usando
            document.dispatchEvent(new CustomEvent('cart:close'));
            document.body.dispatchEvent(new CustomEvent('cart:close'));
            
            // 3. Intentar ocultar directamente con CSS si todo lo demás falla
            cartPopup.style.display = 'none';
            console.log('Popup ocultado manualmente');
          }, autoCloseTime);
        }
      });
    });
    
    // Iniciar la observación de cambios en el DOM
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'open']
    });
    
    console.log('Auto-cierre del carrito configurado');
  }
  
  // Iniciar la funcionalidad cuando la página esté completamente cargada
  window.addEventListener('load', setupAutoCloseCart);
  
  // Como respaldo, también intentamos iniciar después de un breve retraso
  setTimeout(setupAutoCloseCart, 1000);
});